const _ = require('lodash')
const isValid = (rule, value) => {
	let result = true
	switch (rule.NAME)
	{
		case 'MAX_LENGTH':
			result = isValidMaxLength(rule, value)
			break

		case 'LENGTH':
			result = isValidLength(rule, value)
			break

		case 'NUMERIC':
			result = isNumeric(value)
			break

		case 'VALID_VALUES':
			result = isValidValue(rule.VALUE, value)
			break

		case 'REG_EXP':
			result = isValidFormat(rule.VALUE, value)
			break
		default:
			result = true
			break
	}
	return result
}

const isValidMaxLength = (rule, value) => {
	if(!_.isNil(value)){
		let val = value.toString()
		return val.length <= rule.VALUE
	} else {
		return false
	}
}

const isValidLength = (rule, value) => {
	if(!_.isNil(value)){
		let val = value.toString()
		return val.length == rule.VALUE
	} else {
		return false
	}
}

const isNumeric = (value) => {
	return !isNaN(parseFloat(value)) && isFinite(value)
}

const isValidValue = (validValues, value) => {
	if(!_.isNil(value)){
		let val = value.toString()
		return _.includes(validValues, val.toUpperCase())
	} else {
		return false
	}
}

const isValidFormat = (pattern, value) => {
	if(!_.isNil(value)){
		const regex = new RegExp(pattern)
		return regex.test(value)
	} else {
		return false
	}
}

module.exports = {
	isValid,
	isValidMaxLength,
	isValidLength,
	isNumeric,
	isValidValue,
	isValidFormat
}
